import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { ServiceThreadSpinner, NotificationSettings } from ".";
import { api, UserContext } from "../utils";

export default function CustomerInformation(props) {
   const userCtx = useContext(UserContext);
   const navigate = useNavigate();
   const [billingAddress, setBillingAddress] = useState();
   const [customerId, setCustomerId] = useState(props.customerId);
   const [flags, setFlags] = useState();
   const [loaded, setLoaded] = useState(false);
   const [mainAddress, setMainAddress] = useState();

   useEffect(() => {
      let newLoaded = loaded;
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId);
         newLoaded = false;
      }
      if (loaded !== newLoaded) {
         setLoaded(newLoaded);
      }
      if (!newLoaded) {
         setMainAddress();
         setBillingAddress();
         let cust = props.customerId;
         api.fetch(`Customer/GetPrimaryAddressInfo/${cust}`).then((response) => {
            if (response.data.success) {
               setFlags(response.data.flags);
               _.forEach(response.data.addresses, (address) => {
                  if (address.addressType === "MAIN") {
                     setMainAddress(address);
                  } else {
                     setBillingAddress(address);
                  }
               });
            }
            //setLoaded(true);
         })
            .catch(api.catchHandler)
            .finally(setLoaded(true));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId]);

   return (
      <>
         <span className="h2 me-2" children="Customer Information" />{" "}
         <span className="text-muted">Customer: {props.customerId}</span>
         {userCtx.currentUser && userCtx.currentUser.isAPUCS && (
            <Button
               children="Edit UPS Accounts"
               className="shredButton float-end ms-2"
               onClick={() => navigate(`/ups-accounts/${props.customerId}`)}
            />
         )}
         {userCtx.currentUser && userCtx.currentUser.isAPUCS && (
            <Button
               children="Edit"
               className="shredButton float-end ms-2"
               onClick={() => navigate(`/ea/Customer/${props.customerId}`)}
            />
         )}
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            <Row className="px-4">
               <Col xs={4}>
                  <span className="h5 me-2">MAIN ADDRESS</span>
                  <Row>
                     <span>{mainAddress && mainAddress.address1}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && mainAddress.address2}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && mainAddress.address3}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && `${mainAddress.city}, ${mainAddress.state} ${mainAddress.zip}`}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && `Contact: ${_.startCase(_.lowerCase(mainAddress.contact))}`}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && `Phone: ${mainAddress.formattedPhone}`}</span>
                  </Row>
                  <Row>
                     <span>{mainAddress && `Fax: ${mainAddress.formattedFax}`}</span>
                  </Row>
                  {mainAddress
                     ? _.map(mainAddress.emailList, (email) => {
                        return (
                           <Row key={email}>
                              <a href={`mailto:${email}`} className="shredLink">
                                 {email}
                              </a>
                           </Row>
                        );
                     })
                     : null}
               </Col>
               <Col xs={4}>
                  <span className="h5">BILLING ADDRESS</span>
                  <Row>
                     <span>{billingAddress && billingAddress.address1}</span>
                  </Row>
                  <Row>
                     <span>{billingAddress && billingAddress.address2}</span>
                  </Row>
                  <Row>
                     <span>{billingAddress && billingAddress.address3}</span>
                  </Row>
                  <Row>
                     <span>{billingAddress && `${billingAddress.city}, ${billingAddress.state} ${billingAddress.zip}`}</span>
                  </Row>
                  <Row>
                     <span>
                        {billingAddress && `Contact: ${_.startCase(_.lowerCase(billingAddress.contact))}`}
                     </span>
                  </Row>
                  <Row>
                     <span>{billingAddress && `Phone: ${billingAddress.formattedPhone}`}</span>
                  </Row>
                  <Row>
                     <span>{billingAddress && `Fax: ${billingAddress.formattedFax}`}</span>
                  </Row>
                  {billingAddress
                     ? _.map(billingAddress.emailList, (email) => {
                        return (
                           <Row key={email}>
                              <a href={`mailto:${email}`} className="shredLink">
                                 {email}
                              </a>
                           </Row>
                        );
                     })
                     : null}
               </Col>
               <Col xs={4}>
                  <span className="h5">EMAIL SETTINGS</span>
                  <Row className="mt-3 mb-2">
                     Invoices will be sent via the following method(s)
                  </Row>
                  <NotificationSettings
                     type={"Invoice"}
                     flags={flags}
                     setFlags={setFlags}
                     disabled={!(userCtx && userCtx.currentUser && userCtx.currentUser.isAPUCS)}
                  />
                  <Row className="mt-5 mb-2">
                     Orders will be sent via the following method(s):
                  </Row>
                  <NotificationSettings
                     type={"Order"}
                     flags={flags}
                     setFlags={setFlags}
                     disabled={!(userCtx && userCtx.currentUser && userCtx.currentUser.isAPUCS)}
                  />
               </Col>
            </Row>
         </ServiceThreadSpinner>
      </>
   );
}
